export const SCAND_IMAGE_LIST_PRESET = [
  {
    displayedName: 'Ванная из натуральных материалов',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'vannaya-iz-naturalnyh-materialov',
    style: 'scand',
  },
  {
    displayedName: 'Вдохновляющие мотивы в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'vdohnovlyayushchie-prirodnye-motivy-v-vannoy-komnate',
    style: 'scand',
  },
  {
    displayedName: 'Ванная комната в серых оттенках',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'vannaya-komnata-v-seryh-ottenkah-s-derevyannymi-akcentami-v-stile-kantri',
    style: 'scand',
  },
  {
    displayedName: 'Дизайн ванной для эконом-сегмента',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'dizayn-vannoy-dlya-ekonom-segmenta',
    style: 'scand',
  },
  {
    displayedName: 'Легкость и природная гармония в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'legkost-i-prirodnaya-garmoniya-v-vannoy-komnate',
    style: 'scand',
  },
  {
    displayedName: 'Стиль ванной комнаты, который расскажет о вас',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'stil-vannoy-komnaty-kotoryy-rasskazhet-o-vas',
    style: 'scand',
  },
  {
    displayedName: 'Легкий оттенок природы в функциональной ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'legkiy-ottenok-prirody-v-funkcionalnoy-vannoy-komnate',
    style: 'scand',
  },
  {
    displayedName: 'Минималистичная ванная комната в скандинавском стиле',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg'],
    productName: 'minimalistichnaya-vannaya-komnata-v-skandinavskom-stile',
    style: 'scand',
  },
  {
    displayedName: 'Ванная комната для весёлого времяпровождения',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'vannaya-komnata-dlya-veselogo-vremyaprovozhdeniya',
    style: 'scand',
  },
  {
    displayedName: 'Ванная комната цвета морской волны',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'vannaya-komnata-cveta-morskoy-volny',
    style: 'scand',
  },
  {
    displayedName: 'Ванная комната "Голубая лагуна"',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg'],
    productName: 'vannaya-komnata-golubaya-laguna',
    style: 'scand',
  },
  {
    displayedName: 'Эргономичный дизайн маленькой ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'ergonomichnyy-dizayn-malenkoy-vannoy-komnaty',
    style: 'scand',
  },
  {
    displayedName: 'Простой и геометричный дизайн ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg'],
    productName: 'prostoy-i-geometrichnyy-dizayn-vannoy-komnaty',
    style: 'scand',
  },
];
